import api from '../api/axios';

// Helper function to clean phone number for search
const cleanPhoneForSearch = (query) => {
  if (!query) return query;
  
  // Remove all non-digit characters
  const cleaned = query.replace(/\D+/g, '');
  
  // If it looks like a phone number (7+ digits)
  if (cleaned.length >= 7) {
    // Remove leading '1' for US numbers (11 digits starting with 1)
    if (cleaned.length === 11 && cleaned.startsWith('1')) {
      return cleaned.substring(1);
    }
    return cleaned;
  }
  
  // Otherwise return original query (it's a name or email)
  return query;
};

const getAllClients = (skip = 0, take = 1000000) => {
  const response = api.get(
    `/client?skip=${skip}&take=${take}&sort=id%2Casc`,
  );

  return response;
};

const getClientById = (id) => {
  const response = api.get(`/client/${id}`);

  return response;
};

const create = (client) => {
  const response = api.post(`/client`, client);

  return response;
};

const update = (id, updatedClient) => {
  const response = api.patch(`/client/${id}`, updatedClient);

  return response;
};

const remove = (id) => {
  const response = api.delete(`/client/${id}`);

  return response;
};

const searchRequest = (skip = 0, take = 1000000, query, widthDeleted = false, options = {}) => {
  const searchQuery = cleanPhoneForSearch(query);
  const response = api.get(`/client?skip=${skip}&take=${take}&sort=id%2Casc&query=${searchQuery}`, { ...options });

  return response;
};

const getClientToken = (id) => {
  const response = api.get(`client/${id}/token`);

  return response;
};

const clientsServices = {
  getAllClients,
  getClientById,
  create,
  update,
  remove,
  searchRequest,
  getClientToken,
};

export default clientsServices;
